<template>
  <div class="page">
    <div class="top-bar"><div class="back" @click="back">< 返回</div>《{{pageTitle}}》</div>
    <div class="toolbar">

      <div class="button" type="button" @click="scaleX()">缩小</div>
      <div class="button" type="button" @click="scaleD()">放大</div>
    </div>
    <div class="pdf-view"
         ref="pdf1">
      <pdf
        v-for="i in numPages0"
        :key="i"
        :page="i"
        :src="pdfSrcList[0]"
      ></pdf>
    </div>
    <div class="pdf-view"
         ref="pdf2">
      <pdf
        v-for="i in numPages1"
        :key="i"
        :page="i"
        :src="pdfSrcList[1]"
      ></pdf>
    </div>
    <div class="pdf-view"
         ref="pdf3">
      <pdf
        v-for="i in numPages2"
        :key="i"
        :page="i"
        :src="pdfSrcList[2]"
      ></pdf>
    </div>

    <!--    <div class="pdf-view"-->
    <!--         v-for="(pdfItem,index) in pdfSrcList"-->
    <!--         :key="index"-->
    <!--         ref="pdf">-->
    <!--      <pdf-->
    <!--        v-for="i in numPages0"-->
    <!--        :key="i"-->
    <!--        :src="pdfItem"-->
    <!--        :page="i"-->
    <!--        style="width: 100%"-->
    <!--      ></pdf>-->
    <!--    </div>-->
    <!--    <div class="pdf-view"-->
    <!--         v-for="(pdfItem,index) in pdfSrcList"-->
    <!--         :key="index"-->
    <!--         ref="pdf">-->
    <!--      <pdf-->
    <!--        v-for="i in numPagesList"-->
    <!--        :key="i"-->
    <!--        :src="pdfItem"-->
    <!--        :page="i"-->
    <!--        style="width: 100%"-->
    <!--      ></pdf>-->
    <!--    </div>-->
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory";
import {number} from "echarts/lib/export";
var obj = require("@/api/api.js");
export default {
  name: "agreeContent",
  components:{
    pdf
  },
  data() {
    return {
      pdfSrc: '/static/InsuranceClause.pdf',
      pdfSrcList:[],
      numPages: 0,
      numPages0: 0,
      numPages1: 0,
      numPages2: 0,
      numPagesList:[],
      scale: 100,
      pageTitle:'',
      agreed:0,
      isApplicant:''
    }
  },
  created() {
    this.pageTitle = this.$route.query.riskname
  },
  methods:{
    hasRead(){
      let queryParam = this.$route.query
      if(queryParam.agreed==1)return
      let { saveHouseholdReadlnfo } = obj;
      let param = {
        proposalno:queryParam.proposalno,
        phoneno:queryParam.phoneno,
        eletype:queryParam.type
      }
      this.$http
        .post(saveHouseholdReadlnfo, param)
        .then((res) => {
          var result = res.data;
          console.log(result.code)
          if (result.code == "0000") {
            this.agreed = 1
            this.back()
          }
        });
    },
    back(){
      this.$router.go(-1)
    },
    //放大
    scaleD() {
      this.scale += 25;
      this.$refs.pdf1.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf2.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf3.style.width = parseInt(this.scale) + "%";
    },
    //缩小
    scaleX() {
      if (this.scale <= 100) {
        this.scale = 100
        return;
      }
      this.scale -= 25;
      console.log(this.scale)
      this.$refs.pdf1.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf2.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf3.style.width = parseInt(this.scale) + "%";
    },
  },

  beforeRouteLeave(to,from,next){
    this.$destroy()
    next()
  },
  beforeRouteEnter(to, from, next) {
    // 路由守卫刚刚进入是没有实例化界面的，不能使用this
    let queryParam = to.query
    console.log()
    next(vm => {
      let { hubeiQueryRiskPDF } = obj;
      console.log(queryParam)
      vm.$http
        .post(hubeiQueryRiskPDF, { "riskCode":queryParam.riskcode,"type": "2-3-4" })
        .then((res) => {
          var result = res.data;
          console.log(result.base64strs)
          vm.pdfSrcList = []
          if(result.base64strs[0]!=null||result.base64strs[1]!=null||result.base64strs[2]!=null){
            result.base64strs.forEach((item,index)=>{
              console.log(item)
              if(item){
                // vm.pdfSrc = pdf.createLoadingTask({
                vm.pdfSrcList[index] = pdf.createLoadingTask({
                  url: `data:application/pdf;base64,${item}`, CMapReaderFactory() {
                    const CMapReader = new CMapReaderFactory();
                    this.fetch = function (query) {
                      return CMapReader.fetch(query).then((data) => {
                        return {
                          // 重建一个Uint8Array，修复第二次打开不能显示后端动态添加文字的问题
                          cMapData: new Uint8Array(data.cMapData),
                          compressionType: data.compressionType,
                        };
                      });
                    };
                  }
                })
                vm.pdfSrcList[index].promise.then(respdf => {
                  vm[`numPages${index}`] =  respdf.numPages
                })
              }else{
                vm.pdfSrcList[index] = null
                vm.numPagesList[index] = null
              }
            })
            console.log(vm.pdfSrcList)
            console.log(vm.numPagesList)
            vm.$forceUpdate()
          }
          // if (result.code == "0000") {
          //   vm.pdfSrc = pdf.createLoadingTask({
          //     url: `data:application/pdf;base64,${result.data.base64str}`, CMapReaderFactory() {
          //       const CMapReader = new CMapReaderFactory();
          //       this.fetch = function (query) {
          //         return CMapReader.fetch(query).then((data) => {
          //           return {
          //             // 重建一个Uint8Array，修复第二次打开不能显示后端动态添加文字的问题
          //             cMapData: new Uint8Array(data.cMapData),
          //             compressionType: data.compressionType,
          //           };
          //         });
          //       };
          //     }
          //   })
          //   vm.pdfSrc.promise.then(respdf => {
          //     vm.numPages = respdf.numPages
          //   })
          //
          //
          // }
        });

    })
  },

}
</script>

<style scoped>
.iframe{
  width: 100%;
  height: 90vh
}
page{
  background-color: #FFFFFF;
}
.page{
  //background-color: #FFFFFF;
  padding-bottom: 1px;
  padding-top: 80px;
  //width: 100vw;
  //width: 100%;
}
.top-bar{
  width: 100vw;
  height: 45px;
  background: #f6fff8;
  //background:linear-gradient(#44dc00, #f6fff8);
  font-size: 16px;
  text-align: center;
  line-height: 45px;
  position: fixed;
  z-index: 100;
  top: 0;
  //color: #FFFFFF;
}
.back{
  position: absolute;
  color: #00a80d;
  width: 60px;
  left: 5px;
  font-size: 16px;
  top: 5px;
  line-height: 35px;
  height: 35px;
}
.pdf-view{
  margin-top: 20px;
  width: 100vw;
  overflow-y: scroll;
}

.toolbar{
  width: 100vw;
  height: 50px;
  position: fixed;
  background: #f6fff8;
  top: 45px;
  left: 0;
  z-index: 10000;
  align-items: center;
  justify-content: center;
  display:flex;
  border-top: #8bf762 1px solid;
  border-bottom: #8bf762 1px solid;
}
.toolbar .button{
  width: 120px;
  text-align: center;
  font-size: 14px;
  margin: 10px;
  height: 30px;
  line-height: 30px;
  background-color: #daf8cc;
  color: #288400;
  border-radius: 5px;
  border-color: #ffffff;
}
.readed{
  margin: 60px 30px ;
  width: calc(100% - 60px);
  height: 45px;
  border: 0;
  text-align: center;
  line-height: 45px;
  border-radius: 5px;
  background-color: #60be31;
  color: #fff;
  font-size: 16px;
  -webkit-appearance: none;

}
.agreed{
  background-color: #8a8a8a !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/KnowCard/knowCardDetail.vue